import React from 'react';

const NotificationSettingFormModal = React.lazy(() => import('../components/FormModal'));
const notificationSettingModalRegistry = {
    notification_notificationSettingId: NotificationSettingFormModal
};
export default notificationSettingModalRegistry;
